import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDialog } from '../../shared/context';
import { Button, Box } from '@mui/material';
import LinkSectorSubSectorConsult from '../layout/linkSectorSubSector/LinkSectorSubSectorConsult';
import LinkSectorSubSectorRegistre from '../layout/linkSectorSubSector/LinkSectorSubSectorRegistre';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LinkSectorSubSectorDialog = ({ handleCancel }) => {
  const sectorUserDialog = useDialog('linkSectorSubSectorDialog');
  const [getComponent, setComponent] = useState('consult');
  const [getTitle, setTitle] = useState('Vincular Setores com Sub-Setores');

  const handleChangeComponent = (title, component) => {
    setComponent(component);
    setTitle(title);
  };

  return (
    <Dialog
      open={sectorUserDialog.isDialogOpen()}
      TransitionComponent={Transition}
      keepMounted
      onClose={sectorUserDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle sx={{ fontSize: '2em' }}>{getTitle}</DialogTitle>
      <DialogContent>
        <Box>
          {getComponent === 'consult' ? (
            <LinkSectorSubSectorConsult handleChangeComponent={handleChangeComponent} />
          ) : (
            <LinkSectorSubSectorRegistre handleChangeComponent={handleChangeComponent} />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkSectorSubSectorDialog;
